import ScriptLoader from '../../Core/ScriptLoader';
import Url from '../../Core/Url/Url';

export default class Eplanning {
    constructor(options) {
        this.options = options;

        this.scriptLoader = new ScriptLoader({
            src: Url.FromCurrentProtocol('sakimg.e-planning.net/layers/epl-41.min.js')
        });
    }

    Load() {
        const $elements = document.querySelectorAll('[data-module="Eplanning"]');

        if ($elements.length === 0)
            return;

        this.scriptLoader.Load()
            .then(() => {
                this._initialize();

                $elements.forEach(($element) => {
                    const spaceId = $element.dataset.eplanningId;

                    $element.innerHTML = `<div id="eplAdDiv${spaceId}"></div>`;

                    this._showSpace(spaceId);
                });
            });
    }

    _initialize() {
        if (document.epl.eplReady())
            return;

        document.epl.eplInit(this.options);
    }

    _showSpace(spaceId) {
        if (this.options.eIs.indexOf(spaceId) === -1)
            return;

        document.epl.showSpace(spaceId);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Eplanning/Eplanning.js